import type { TradeInAemDetailFormItem } from "../../utils/types";

export const TRADE_IN_AEM_INIT_FORM_ITEMS = "tradeInAemVehicleDetails/setFormItems";
type TradeInAemInitFormItems = {
    type: typeof TRADE_IN_AEM_INIT_FORM_ITEMS;
    formItems: Record<string, TradeInAemDetailFormItem>;
};
export const tradeInAemInitFormItems = (
    formItems: Record<string, TradeInAemDetailFormItem>,
): TradeInAemInitFormItems => ({
    type: TRADE_IN_AEM_INIT_FORM_ITEMS,
    formItems,
});

export const TRADE_IN_AEM_SET_FORM_ITEM_VALUE = "tradeInAemVehicleDetails/setFormItemValue";
export type TradeInAemSetFormItemValue = {
    type: typeof TRADE_IN_AEM_SET_FORM_ITEM_VALUE;
    formItemKey: string;
    formItemValue: string | string[];
};
export const tradeInAemSetFormItemValue = (
    formItemKey: string,
    formItemValue: string | string[],
): TradeInAemSetFormItemValue => ({
    type: TRADE_IN_AEM_SET_FORM_ITEM_VALUE,
    formItemKey,
    formItemValue,
});

export type TradeInAemVehicleDetailsActions = TradeInAemInitFormItems | TradeInAemSetFormItemValue;
